var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"ma-4",class:{
        'text-xs-left': _vm.textPosition === 'left',
        'text-xs-center': _vm.textPosition === 'center',
        'text-xs-right': _vm.textPosition === 'right',
    },attrs:{"column":""}},[(_vm.icon)?_c('v-icon',{staticClass:"mb-3",attrs:{"size":"72"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"body-1 mt-3"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }